import { Navigate, Outlet } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { Loader2 } from 'lucide-react'
import { api } from '@/lib/api'

interface MeResponse {
  id: string
  email: string
  isAdmin: boolean
}

/**
 * AdminRoute - 관리자 전용 라우트 보호
 *
 * /api/auth/me를 호출하여 실시간으로 관리자 여부 확인
 * - 미인증(401): 메인 페이지로 리다이렉트
 * - 인증됐지만 관리자 아님: 403 페이지로 리다이렉트
 */
export function AdminRoute() {
  const { data, isLoading, error } = useQuery({
    queryKey: ['auth', 'me', 'admin-check'],
    queryFn: () => api.get<MeResponse>('/auth/me'),
    retry: false,
    staleTime: 1000 * 10, // 10초 캐시
  })

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-slate-400" />
      </div>
    )
  }

  if (error) {
    // 401 Unauthorized 등 인증 실패
    return <Navigate to="/" replace />
  }

  if (!data?.isAdmin) {
    // 인증됐지만 관리자 아님
    return <Navigate to="/forbidden" replace />
  }

  return <Outlet />
}
